<template lang="pug">
  .product-container
    .product-header
      .product-title {{ $t('贵了么 - 营销资源开放平台') }}
      .product-desc
        p {{ $t('连接需求端与供给端，涵盖媒介、营销服务、KOL等7个大类资源。') }}
        p {{ $t('对接超过1,000家供应商的近300个媒体资源，20,000个KOL。') }}
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('咨询合作') }}
      .product-img
        img(
          style="width: 700px;margin-top:50px"
          src="@/assets/guileme-1.png"
        )
    .product-content-container
      .product-content-item
        img(
          style="height: auto"
          src="@/assets/guileme-2.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('找供给') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('需求端') }}
          .desc {{ $t('针对需求端，任何用户均可在贵了么的公开市场上搜寻所需要的营销资源，平台总计分为7大类：媒体资源、营销服务、KOL、营销峰会、行业媒体、微信群、招聘。用户如果发现感兴趣的资源，可直接与对应供应商取得联系，贵了么致力于帮助广告主直连核心代理商，避开层层中间商。') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('供给端') }}
          .desc {{ $t('针对供给端，任何供应商均可以在线提交申请，过审后免费入驻贵了么平台，供应商不仅能快速让各类广告主、代理商发现自己从而获取潜在合作机会，也可通过入驻贵了么拥有供应商自己的主页，全方位展示相关售卖资源、服务客户、服务行业、公司简介等各类优势。') }}
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title {{ $t('发需求') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('需求端') }}
          .desc {{ $t('针对需求端，用户除了可以在“找供给”中主动搜索标准化资源外，还可以在此模块发布非标/定制化/非常规需求，贵了么提供了一个快速对接多家靠谱供应商的有效渠道，用户可以选择“公开发布”或“平台托管”任意一种模式发布需求。') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('供给端') }}
          .desc {{ $t('针对供给端，所有供应商都可以免费且高效的对接各类需求，同时在系统中获取当前需求的状态及进度。') }}
        img(
          style="height: auto"
          src="@/assets/guileme-3.png"
        )
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          ul.clients-say__case__content
            li(:class="{'active': activeIndex === 0}")
              p {{ $t('入驻贵了么后，等于在不影响原先公司销售体系的情况下，多了一个免费的销售宣传渠道，客户咨询量也比较可观，平均一周有5到7个咨询客户。同时感谢复歌团队愿意聆听我们提出的各类建议更好的完善贵了么平台。') }}
            li(:class="{'active': activeIndex === 1}")
              p {{ $t("我们通过贵么尝试了媒体外包服务，获得了良好的效果，贵了么不仅有助于我们有效地从媒体供应商获得最优价格，而且可以快速测试媒体供应商合作伙伴的各项能力。贵了么大大提高了营销投资的效率，感谢复歌团队！") }}
          ul.clients-say__case__avators.f.f-sa
            li(
              :class="{'active_li': activeIndex === 0}"
              @mouseover="activeIndex = 0"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/guileme_avator-1.png"
                )
              p
                | 陈家辉
                br
                span
                  | CEO / Hi 云
            li(
              :class="{'active_li': activeIndex === 1}"
              @mouseover="activeIndex = 1"
            )
              div
                img(
                  alt="avator"
                  src="@/assets/guileme_avator-2.png"
                )
              p
                | Sean Shen
                br
                span Bayer Byepest Venture Lead

    contact
</template>

<script>
import PageFooter from '@/components/PageFooter'
import Contact from '@/components/Contact'
export default {
  components: {
    PageFooter,
    Contact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/guileme&buttonName=申请Demo账号')
    }
  }
}
</script>
